
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/website-integration",
      function () {
        return require("private-next-pages/docs/website-integration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/website-integration"])
      });
    }
  